<template>
  <div ref="navBar" class="navbar" :class="{ 'navbar-hovered':showHover }" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <div class="navbar-inner" :style="{ padding: '0 ' + sidePadding + 'px' }">
      <!-- logo 点击跳首页 -->
      <img :src="showHover ? hoverLogo : defaultLogo" alt="logo" class="navbar-logo" @click="handleLogoClick" />

      <!-- 移动端汉堡菜单 -->
      <div class="navbar-mobile-toggle" @click="menuOpen = !menuOpen">
        <span :class="{ 'open1': menuOpen }"></span>
        <span :class="{ 'open2': menuOpen }"></span>
        <span :class="{ 'open3': menuOpen }"></span>
      </div>

      <!-- 菜单 -->
      <ul class="nav-list" :class="{ 'open': menuOpen ,'collapsed': !menuOpen }">
        <li
          v-for="(item, index) in menu"
          :key="index"
          class="nav-item"
          :class="{ 'selected': selectedMenu === index }"
          @click="handleMenuClick(item, index)"
        >
          <span class="nav-label" :class="{ 'text-dark': showHover, 'nav-selected': selectedMenu === index }">{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovered: false,
      scrolled: false,
      selectedMenu: null,
      sidePadding: 0,
      menuOpen: false, // 移动端菜单开关
      defaultLogo: require('../assets/images/home/headerTitle_logo.png'),
      hoverLogo: require('../assets/images/home/headerTitle_logo_hover.png'),
      menu: [
        { label: this.$t('message.headerProducts'), path: '/productDetail' },
        { label: this.$t('message.headerAboutUs'), path: '/about' },
        { label: this.$t('message.headerClinicalTrail'), path: '/clinicalDetail' }
      ]
    }
  },
  computed: {
    showHover() {
      if (window.innerWidth <= 768) {
        return true
      }
      if (this.$route.path === '/' || this.$route.path === '/clinicalDetail') {
        return this.isHovered || this.scrolled
      } else {
        return true
      }
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        // 每次路由切换时都要重置菜单状态
        this.menuOpen = false
        if (newPath === '/') {
          this.isHovered = false
          this.scrolled = false
          this.selectedMenu = null
          window.addEventListener('scroll', this.handleScroll)
        } else if (newPath === '/clinicalDetail') {
          // 临床试验页：背景透明，但菜单选中
          this.isHovered = false
          this.scrolled = false
          this.selectedMenu = this.menu.findIndex(m => m.path === newPath)
          window.addEventListener('scroll', this.handleScroll)
        } else {
          this.isHovered = true
          this.scrolled = true
          this.selectedMenu = this.menu.findIndex(m => m.path === newPath)
          window.removeEventListener('scroll', this.handleScroll)
        }
      }
    }
  },
  mounted() {
    this.updatePadding()
    window.addEventListener('resize', this.updatePadding)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.updatePadding)
  },
  methods: {
    handleLogoClick() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    handleMenuClick(item, index) {
      if (item.path) {
        if (this.$route.path !== item.path) {
          this.$router.push(item.path)
        } else {
          this.selectedMenu = index
        }
      }
      // 移动端点击后关闭菜单
      this.menuOpen = false
    },
    handleScroll() {
      const firstScreenHeight = window.innerHeight
      this.scrolled = window.scrollY > firstScreenHeight - 64
    },
    updatePadding() {
      if (window.innerWidth <= 768) {
        this.sidePadding = 20
      } else {
        this.sidePadding = window.innerWidth * 0.18
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  height: 58px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

.navbar-hovered {
  background-color: #f7f9f9 !important;
  border-bottom: 1px solid #f1ecec !important;
}

.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navbar-logo {
  height: 32px;
  width: auto;
  cursor: pointer;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  gap: 4rem;
}

.nav-item {
  position: relative;
  cursor: pointer;
}

/* 默认 hover 下划线 */
.nav-item::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #00acf8;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.nav-item:hover::after {
  transform: scaleX(1);
}

.nav-item.selected::after {
  content: none;
}

.nav-label {
  color: white;
  font-size: var(--header-size);
  transition: color 0.3s ease, background-color 0.3s ease;
}

.nav-label.text-dark {
  color: black;
}

.nav-label.nav-selected {
  background-color: #00acf8;
  color: #ffffff;
  padding: 5px 15px;
  border-radius: 15px;
  font-weight: 400;
}

/* 移动端适配 */
/* 移动端适配 */
@media screen and (max-width: 768px) {
  .anchor-navbar{
    height: 3.2rem;
  }


  /* 隐藏 gap 和默认竖排样式 */
  .nav-list {
    position: fixed; /* 固定在屏幕 */
    top: 58px;
    right: 0; /* 从右侧滑出 */
    height: 100vh; /* 全屏高度 */
    width: 55vw; /* 菜单宽度 */
    background-color: #ffffff;
    flex-direction: column;

    /* box-shadow: -2px 0 10px rgba(0, 0, 0, 0.15); */
    transform: translateX(100%); /* 默认隐藏在右边 */
    transition: transform 0.3s ease;
    z-index: 9999;
    gap: 0rem;
  }

  .nav-list.open {
    transform: translateX(0); /* 打开时滑入屏幕 */
  }

  .nav-list.collapsed .nav-item {
    border-bottom: none !important;
  }

  .nav-list.open .nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  .nav-item {
    padding: 36px 40px 36px 0;
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.05); */
    display: flex;
    justify-content: flex-end;

    width: 100%;
  }

  .nav-label {
    font-size: 1.5rem;
    color: #000;
  }

  .nav-label.nav-selected {
    padding: 5px 0 5px 15px;
    background-color: transparent;
    color: #00acf8;
  }

  /* 隐藏下划线 */
  .nav-item::after {
    display: none;
  }

  /* 汉堡菜单保持不变 */
  .navbar-mobile-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 20px;
    height: 15px;
    cursor: pointer;
  }

  .navbar-mobile-toggle span {
    display: block;
    height: 2px;
    background-color: #000;
    border-radius: 2px;
    transition: 0.3s;
  }

  .navbar-mobile-toggle span.open1 {
    transform: rotate(45deg) translate(5px, 5px);
  }
  .navbar-mobile-toggle span.open2 {
    opacity: 0;
  }
  .navbar-mobile-toggle span.open3 {
    transform: rotate(-45deg) translate(5px, -5px);
  }
}
</style>
